import axios from "axios";
import { auth } from "../firebase";
import { toast } from "sonner";

// Create an Axios instance with your backend's base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000", // Change if your backend runs elsewhere
});

// const api = axios.create({
//   baseURL: "https://678bf3b2438b.ngrok-free.app",
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//     "ngrok-skip-browser-warning": "69420",
//   },
// });

// Interceptor to attach Firebase ID token to every request
api.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      // Removing the print statement for the firebase token for security reasons.
      // console.log("FIREBASE ID TOKEN:", token);
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor to show error toast on API failures
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      error.message ||
      "An error occurred";
    
    toast.error(message);
    return Promise.reject(error);
  }
);

export default api;
